angular.module('unica_campaign_template.campaign_template_services')

.factory('CampaignTemplateCreateService', function($http, getBaseApiURL) {

	var campaignTemplateCreateService = {};

	campaignTemplateCreateService.create = function( eventId, campaignTemplateData ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign-template/create/' + eventId,
			data: campaignTemplateData
		}).then(function(result) {

			if ( result ) {
				return result.data.campaign_template;
			}

		});
	};

	campaignTemplateCreateService.clone = function( campaignTemplateId ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign-template/clone/' + campaignTemplateId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return campaignTemplateCreateService;

});